// ripped from mobile
// @see https://gitlab.com/modernhealth/mobile/-/blob/9896ad3f/src/common/helpers/truncateText.ts

interface TruncateConfig {
    maxLength: number;
    headLength: number;
    tailLength: number;
    ellipsis?: string;
}

export const truncateText = (
    text: string,
    { maxLength, tailLength, headLength, ellipsis = '[...]' }: TruncateConfig,
) => {
    if (text.length <= maxLength) {
        return text;
    }

    return text.slice(0, headLength) + ellipsis + text.slice(text.length - tailLength);
};
